
enum ColorMode {
    DARK = "dark",
    LIGHT = "light"
}

export {ColorMode as default};